import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'event',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.show_edit_dialog = true
    })
  }
}
